// Importazione dei fogli di stile SASS
import "../scss/frontend.scss";

import "../fonts/Aeonik-ThinItalic.woff2";
import "../fonts/Aeonik-Air.woff";
import "../fonts/Aeonik-Air.woff2";
import "../fonts/Aeonik-AirItalic.woff";
import "../fonts/Aeonik-AirItalic.woff2";
import "../fonts/Aeonik-Black.woff";
import "../fonts/Aeonik-Black.woff2";
import "../fonts/Aeonik-BlackItalic.woff";
import "../fonts/Aeonik-BlackItalic.woff2";
import "../fonts/Aeonik-Bold.woff";
import "../fonts/Aeonik-Bold.woff2";
import "../fonts/Aeonik-BoldItalic.woff";
import "../fonts/Aeonik-BoldItalic.woff2";
import "../fonts/Aeonik-Light.woff";
import "../fonts/Aeonik-Light.woff2";
import "../fonts/Aeonik-LightItalic.woff";
import "../fonts/Aeonik-LightItalic.woff2";
import "../fonts/Aeonik-Medium.woff";
import "../fonts/Aeonik-Medium.woff2";
import "../fonts/Aeonik-MediumItalic.woff";
import "../fonts/Aeonik-MediumItalic.woff2";
import "../fonts/Aeonik-Regular.woff";
import "../fonts/Aeonik-Regular.woff2";
import "../fonts/Aeonik-RegularItalic.woff";
import "../fonts/Aeonik-RegularItalic.woff2";
import "../fonts/Aeonik-Thin.woff";
import "../fonts/Aeonik-Thin.woff2";
import "../fonts/Aeonik-ThinItalic.woff";

// Importazione delle librerie JavaScript
import jQuery from "jquery";
// import gsap from "gsap";
import { Accordion, Dropdown } from "bootstrap";
// import ScrollTrigger from "gsap/ScrollTrigger";
// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

jQuery(function ($) {
  $(document).on("click", ".hamburger--collapse", function () {
    $(this).toggleClass("is-active");
  });

      // Forms
      $(
        "select, input[type=text], input[type=email], input[type=password], textarea"
      ).addClass("form-control");


  // gsap.registerPlugin(ScrollTrigger);

  // gsap.to(".animated-image", {
  //   scrollTrigger: {
  //     trigger: ".half",
  //     start: "top center", // Modifica questi valori in base a quando vuoi che l'animazione inizi
  //     end: "bottom center", // Modifica questi valori in base a quando vuoi che l'animazione finisca
  //     scrub: true, // Permette di legare l'animazione allo scroll invece che farla partire una volta sola
  //   },
  //   objectPosition: "0% 100%", // L'animazione cambia la posizione dell'oggetto da 0% 30% a 0% 50%
  //   ease: "none", // Opzionale, ma fornisce un controllo più fine sull'animazione
  // });

  const swiper = new Swiper(".swiper", {
    // configure Swiper to use modules
    // modules: [Navigation, Pagination],

    // loop: true,
    slidesPerView: 2,
    spaceBetween: 30,
    //freeMode: true,

    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.2,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      880: {
        slidesPerView: 2.2,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: 3.4,
        spaceBetween: 40,
      },
    },

    // If we need pagination
    // pagination: {
    //   el: ".swiper-pagination",
    // },

    // // Navigation arrows
    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },

    // // And if we need scrollbar
    // scrollbar: {
    //   el: ".swiper-scrollbar",
    // },
  });
});
